import axios from 'axios';

export const asyncPost = async (url, data) => {
  const response = await axios.post(url, data);
  return response.data;
};
